export default "__VITE_ASSET__Mkn0wAI4__"